import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { Checkboxes } from "../../../FlowConfigurationInputs";

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function KeyCombination({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.KEY-COMBINATION.';

    const options = {
        checkbox0: { label: label + 'ENTER-TRIGGER' }
    }

    return (
        <>
            <div className="form-element">
                {t(label + 'HEADER')} : <TextInput action={action} inputName="value" variables={variables}
                    setOpenVariable={setOpenVariable} filter="string" />
            </div>
            <div className="form-element">
                <Checkboxes action={action} inputName="enterTrigger" options={options.checkbox0} />
            </div>
            {action.fields.image?.byteValue &&
                <img src={`data:image/jpeg;base64,${action.fields.image.byteValue}`} alt="autommate_keycombination" />}
        </>
    );
}

export default KeyCombination;
